import LocationsService from 'src/services/locations'

class Location {
  constructor (_location) {
    if (typeof _location !== 'undefined') {
      this.id = _location.id ? _location.id : null
      this.folio = _location.folio ? _location.folio : null
      this.name = _location.name ? _location.name : null
      this.group_id = _location.group_id ? _location.group_id : null
      this.address = _location.address ? _location.address : null
      this.contact_number = _location.contact_number ? _location.contact_number : null
      this.lat = _location.lat ? _location.lat : null
      this.long = _location.long ? _location.long : null
      this.timezone = _location.timezone ? _location.timezone : 16
      this.radius = _location.radius ? _location.radius : 100
      if (Array.isArray(_location.franchise_ids)) this.franchise_ids = _location.franchise_ids
      else if (Array.isArray(_location.franchise_id)) this.franchise_ids = _location.franchise_id
      else this.franchise_ids = []
      this.franchise_organization_id = _location.franchise_organization_id ? _location.franchise_organization_id : null
      this.file = null
      this.old_file = _location.file ? _location.file : null
    } else {
      this.id = null
      this.folio = null
      this.name = null
      this.group_id = null
      this.address = null
      this.contact_number = null
      this.lat = null
      this.long = null
      this.timezone = 16
      this.radius = 300
      this.franchise_ids = []
      this.franchise_organization_id = null
      this.file = null
      this.old_file = null
    }
  }

  save () {
    if (!this.id) {
      const form_fields = new FormData()
      form_fields.append('id', this.id)
      form_fields.append('folio', this.folio)
      form_fields.append('name', this.name)
      form_fields.append('group_id', this.group_id)
      form_fields.append('address', this.address)
      form_fields.append('contact_number', this.contact_number)
      form_fields.append('lat', this.lat)
      form_fields.append('long', this.long)
      form_fields.append('timezone', this.timezone)
      form_fields.append('radius', this.radius)
      this.franchise_ids.forEach(id => {form_fields.append('franchise_id[]', id)})
      form_fields.append('franchise_organization_id', this.franchise_organization_id)
      if (this.file !== null) {
        form_fields.append('file', this.file)
      }
      return LocationsService.create(form_fields)
    } else {
      const form_fields = new FormData()
      form_fields.append('id', this.id)
      form_fields.append('folio', this.folio)
      form_fields.append('name', this.name)
      form_fields.append('group_id', this.group_id)
      form_fields.append('address', this.address)
      form_fields.append('contact_number', this.contact_number)
      form_fields.append('lat', this.lat)
      form_fields.append('long', this.long)
      form_fields.append('timezone', this.timezone)
      form_fields.append('radius', this.radius)
      this.franchise_ids.forEach(id => {form_fields.append('franchise_id[]', id)})
      form_fields.append('franchise_organization_id', this.franchise_organization_id)
      form_fields.append('_method', 'put')
      if (this.file !== null) {
        form_fields.append('file', this.file)
      }
      return LocationsService.update(this.id, form_fields)
    }
  }

  static fetch (id) {
    return LocationsService.fetch(id).then(location => {
      return new this(location)
    })
  }

  static delete (id) {
    return LocationsService.delete(id)
  }

  static relatedSummary (id) {
    return LocationsService.relatedSummary(id)
  }
}

export default Location
